namespace Nobox.Nobox {
    export interface QrObject {
        AccountId?: number;
        UserId?: number;
        TenantId?: number;
        QrCodeImgBase64?: string;
        IsError?: boolean;
        ErrMsg?: string;
    }
}
